module.exports = __webpack_public_path__ + "static/media/login.0449d58e.svg";